export const mediaQuery = 'only screen and (min-width: 640px)';

let imgs;
const viewportFractionH = .9,
      viewportFractionW = .8;

export function bootstrap() {
  imgs = document.querySelectorAll('.c-sci__section--wide img');

  imgs.forEach(img => {
    img.dataset.scaled = 'false';
  
    img.addEventListener('click', e => {
      const factor = Math.max(1, Math.min(
        img.naturalHeight / img.offsetHeight,
        img.naturalWidth / img.offsetWidth,
        window.innerHeight*viewportFractionH / img.offsetHeight,
        window.innerWidth*viewportFractionW / img.offsetWidth
      ));

      if (factor === 1) {
        return;
      }
      
      if (img.dataset.scaled == 'false') {
        var scaleUp = function() {
          img.style.transform = `scale(${factor})`;
          img.dataset.scaled = 'true';
        }

        if (wouldBeVisible(img, factor)) {
          scaleUp();
        } else {
          document.scrollingElement.scrollTo({
            top: computeCoordTop(img, factor)
          });

          const scrollendCb = function() {
            document.removeEventListener('scrollend', scrollendCb);
            scaleUp();
          };

          if ('onscrollend' in window) {
            document.addEventListener('scrollend', scrollendCb);
          } else {
            setTimeout(scrollendCb, 200);
          }
        }
      } else {
        img.style.transform = '';
        img.dataset.scaled = 'false';
      }
    });
  });
}

function wouldBeVisible(img, factor) {
  const rect = img.getBoundingClientRect(),
        scaledTop = rect.top - (img.clientHeight * (factor - 1));

  return (scaledTop >= 0 && rect.bottom <= window.innerHeight);
}

// Computes a coordinate to scroll the window to a position
// where the scaled image is vertically centered
function computeCoordTop(img, factor) {
  const scaledHeight = img.clientHeight * factor,
        scaledPositionDelta = img.clientHeight * (factor - 1);
        centerOffset = (window.innerHeight - scaledHeight) / 2;

  return img.offsetTop - scaledPositionDelta - centerOffset;
}